( function () {
	'use strict';

	function slideToggleBase () {
		return {
			'restrict'   : 'A',
			'controller' : function ( $scope ) {
				var container;

				this.addContainer = function ( element ) {
					container = element;
				};

				this.addToggle = function ( element, tooltipMessages, toggleIcons, startHidden ) {
					var tooltips = tooltipMessages;
					var icons    = toggleIcons;
					var isHidden = startHidden;

					// add additional class on toggle, for customized styling
					element.addClass( 'slide-toggle' );
					// add the icon
					element.addClass( icons[ isHidden ] );

					// set the initial tooltip
					$scope.tooltipMessage = tooltips[ isHidden ];

					// handle a click on the toggle element
					element.on( 'click', function () {
						// update the icon
						element
							.removeClass( icons[ isHidden ] )
							.addClass( icons[ !isHidden ] );

						// update the value
						isHidden = !isHidden;

						// slide animation and update tooltip
						container.slideToggle( function () {
							$scope.tooltipMessage = tooltips[ isHidden ];
							$scope.$apply();
						} );
					} );
				};
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'slideToggleBase', slideToggleBase );
} )();
